<template>
  <section>
    <e-filters
      :searching="fetching"
      @search="filterData"
      @reset="resetFiltersLocal"
    >
      <div>
        <b-row>
          <b-col md="4">
            <FormulateInput
              id="movementDate"
              v-model="filters.movementDate"
              type="date-range-picker"
              :label="$t('Período de movimento')"
              :time-picker="false"
            />
          </b-col>
        </b-row>
      </div>
    </e-filters>

    <b-card-actions
      action-refresh
      :show-loading="fetching"
      @refresh="filterData"
    >
      <div slot="title">
        <e-page-size-selector
          :per-page="paging.pageSize"
          @change="pageSizeChange"
        />
      </div>

      <b-table
        ref="reconciliations-table"
        show-empty
        responsive
        striped
        class="bordered"
        :empty-text="getEmptyTableMessage($tc('RECONCILIATION.NAME'), 'female', queryExecuted)"
        :fields="fields"
        :items="reconciliations"
        no-local-sorting
        :sort-by.sync="sorting.sortBy"
        :sort-desc.sync="sorting.sortDesc"
        @sort-changed="getData"
      >
        <template #cell(action)="row">
          <e-grid-actions
            :show-read-only="true"
            :show-update="false"
            :show-delete="false"
            @read-only="onShowDetails(row)"
          />
        </template>
      </b-table>

      <b-row class="pt-1">
        <b-col cols="6">
          <e-pagination-summary
            :current-page="paging.currentPage"
            :per-page="paging.pageSize"
            :total="paging.rowCount"
            :total-on-page="paging.rowsInCurrentPage"
          />
        </b-col>
        <b-col cols="6">
          <b-pagination
            v-model="paging.currentPage"
            align="right"
            :total-rows="paging.rowCount"
            :per-page="paging.pageSize"
            aria-controls="reconciliations-table"
            @change="pageChange"
          />
        </b-col>
      </b-row>
    </b-card-actions>
  </section>
</template>

<script>
import { BRow, BCol, BPagination, BTable } from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {
  EPageSizeSelector,
  EPaginationSummary,
  EFilters,
  EGridActions,
} from '@/views/components'
import { reconciliationDomains, statusTypes } from '@/mixins'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCardActions,
    BPagination,
    BTable,
    EPageSizeSelector,
    EPaginationSummary,
    EFilters,
    EGridActions,
  },

  mixins: [statusTypes, reconciliationDomains],

  data() {
    return {
      queryExecuted: false,
      fetching: false,
      edit: false,
      saving: false,
    }
  },

  computed: {
    ...mapState('pages/financial/reconciliation/stripe', [
      'reconciliations',
      'paging',
      'sorting',
      'filters',
    ]),

    fields() {
      return [
        {
          label: this.$t('Ações'),
          key: 'action',
          tdClass: 'text-center',
          thStyle: { width: '100px' },
        },
        {
          label: this.$t('#'),
          key: 'id',
          tdClass: 'text-center',
          sortable: true,
          thStyle: { width: '80px' },
        },
        {
          label: this.$t('Pagamento Stripe Id'),
          key: 'payoutId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Conta Corrente'),
          key: 'checkingAccount.name',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Data Pagamento'),
          key: 'movementDate',
          tdClass: 'text-center',
          thStyle: { width: '100px' },
          formatter: value => this.$options.filters.date(value),
          sortable: true,
        },
        {
          label: this.$t('Valor'),
          key: 'amount',
          tdClass: 'text-right',
          thStyle: { width: '100px' },
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        },
      ]
    },
  },

  mounted() {},

  methods: {
    ...mapActions('pages/financial/reconciliation/stripe/maintain', {
      cleanState: 'cleanState',
      maintainResetFilters: 'resetFilters',
    }),
    ...mapActions('pages/financial/reconciliation/stripe', [
      'setFilter',
      'setCurrentPage',
      'setPageSize',
      'fetchReconciliations',
      'resetFilters',
    ]),

    async getData() {
      this.$nextTick(async () => {
        try {
          this.fetching = true
          await this.fetchReconciliations()
          this.queryExecuted = true
        } catch (error) {
          this.showError({ error })
        } finally {
          this.fetching = false
        }
      })
    },

    resetFiltersLocal() {
      this.resetFilters()
      this.getData()
    },

    filterData() {
      this.setCurrentPage(1)
      this.getData()
    },

    pageSizeChange(pageSize) {
      this.setPageSize(pageSize)
      this.getData()
    },

    pageChange(currentPage) {
      this.setCurrentPage(currentPage)
      this.getData()
    },

    async onShowDetails(row) {
      const { id } = row.item
      this.maintainResetFilters()
      this.$router.push({ name: 'reconciliation-stripe-maintain', params: { id } })
    },
  },
}
</script>

<style></style>
